const products = {
  products: {
    HaifaStimBooster: "Boosts metabolic activity in stressful situations",
    HaifaStimEnergy: "Improves the energy balance of the plant",
    HaifaStimForce: "Saves metabolic energy, supporting the Amino Acid and protein synthesis",
    HaifaStimHumiK: "Supports root activity and uptake of nutrients",
    HaifaStimVigor: "Strengthen and enhances the plant resistance towards abiotic stresses",
    HaifaStimVIM: "Improves soil fertility and nutrient use efficiency",
    HaifaStimVital: "Improves plant performance",
    HaifaStimWallUp: "Optimal mix of selected micronutrients for improving plant resistance to abiotic stresses, enhances growth and maximizes yield",
    HaifaMicroCombi:
      "A stable, water-soluble and non-dusting mixture of metal chelates: Iron, Manganese, Copper, Zinc - all are present as EDTA chelated form",
    PolyFeedFoliar1:
      "Poly-Feed™ Foliar nourishes plants, meeting their precise needs during critical growth phases for maximal yields and top quality.",
    PolyFeedFoliar2: "Crop specific formula",
    PolyFeedStim: "unique combination of natural stimulants and mineral  NPK fertilzers",
    HaifaBonus: "High potassic fertilizer for efficient foliar application  formulas are based on Haifa’s Multi-K™ potassium nitrate.",
  },
};

export default products;
